interface IWholeDiscussionHeaderLineWithCounterProps {
  totalCountOf: "COMMENTS" | "REPLIES";
  totalCount: number;
}

export default function WholeDiscussionHeaderLineWithCounter({
  totalCount,
  totalCountOf,
}: IWholeDiscussionHeaderLineWithCounterProps) {
  return (
    <div className="flex items-center justify-between font-aeonik">
      <strong className="text-sm font-medium tracking-wider text-slate-600 dark:text-gray-400">DISCUSSÃO</strong>

      {totalCount > 0 && (
        <div>
          {totalCountOf === "COMMENTS" && (
            <span className="text-sm font-medium text-slate-500 dark:text-gray-400">
              {totalCount} {totalCount === 1 ? "comentário" : "comentários"}
            </span>
          )}

          {totalCountOf === "REPLIES" && (
            <span className="text-sm font-medium text-slate-500 dark:text-gray-400">
              {totalCount} {totalCount === 1 ? "resposta" : "respostas"}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
